import {Component} from 'inferno';
import {Button, Card, CardBody, CardText} from "inferno-bootstrap";
import {T} from "inferno-i18next";

import Image from "inferno-feather/dist/icons/image";
import Video from "inferno-feather/dist/icons/video";
import Text from "inferno-feather/dist/icons/file-text";
import Audio from "inferno-feather/dist/icons/music";
import Zip from "inferno-feather/dist/icons/archive";
import File from "inferno-feather/dist/icons/file";
import Error from "inferno-feather/dist/icons/x-circle";
import {downloadURI, formatMediaLength, formatSize} from "../../../../utils/util";
import {Entity} from "../../../../utils/types";
import {Configuration} from "../../../../services/configuration";

function displayLength(event: any) {
	try {
		const element = event.target.parentNode.parentNode.parentNode.getElementsByClassName("msg-length")[0];
		element.innerHTML = formatMediaLength(event.target.duration) + " ";
	} catch (e) {
		// ignore
	}
}

function getIcon(format: string): any {
	if (format.indexOf("image") !== -1) {
		return (<Image/>);
	} else if (format.indexOf("text") !== -1) {
		return (<Text/>);
	} else if (format.indexOf("video") !== -1) {
		return (<Video/>);
	} else if (format.indexOf("audio") !== -1) {
		return (<Audio/>);
	} else if (format.indexOf("compressed") !== -1 || format.indexOf("zip") !== -1) {
		return (<Zip/>);
	} else {
		return (<File/>);
	}
}

export function renderAttachment(mime: string, name: string, url: string, size?: string, style: string = "") {
	let content;
	if (mime.indexOf("image") !== -1) {
		style += " border-0";
		content = (
			<CardBody className="p-0" onClick={() => downloadURI(url, name)}>
				<Button color="link" className="p-0 m-0">
					<img crossOrigin="use-credentials" alt={name} src={url} style={{"max-width": "65vw", "max-height": "100%", "border-radius": "10px"}}/>
				</Button>
			</CardBody>
		);
	} else if (mime.indexOf("video") !== -1) {
		style += " border-0";
		content = (
			<CardBody className="p-0">
				<video crossOrigin="use-credentials" controls={true} src={url} onLoadedMetadata={displayLength} style={{"max-width": "65vw", "max-height": "100%", "border-radius": "10px"}}/>
			</CardBody>
		);
	} else if (mime.indexOf("audio") !== -1) {
		content = (
			<CardBody>
				<audio crossOrigin="use-credentials" controls={true} onLoadedMetadata={displayLength} src={url} style={{"max-width": "65vw", "max-height": "100%"}}/>
			</CardBody>
		);
	} else {
		return (
			<div className="d-flex flex-column">
				<Card className={style}>
					<CardBody className="p-0">
						<Button className="border-0 w-100" style={{"white-space": "normal", "text-align": "start"}} onClick={() => downloadURI(url, name)} outline>
							{getIcon(mime)}
							<CardText className="d-inline ml-2 text-break">
								{name}
							</CardText>
						</Button>
					</CardBody>
				</Card>
				<small className="align-self-end text-secondary m-1" style={{"max-width": "65vw"}}>
					{size && <span><T className="d-inline" i18nKey="VCC_XMSG_ITEM_SIZE">x</T>: {size} </span>}
					<span><T className="d-inline" i18nKey="VCC_XMSG_ITEM_FORMAT">x</T>: {mime}</span>
				</small>
			</div>
		);
	}

	return ([
		<Card className={style}>
			{content}
		</Card>,
		<small className="align-self-end text-secondary m-1" style={{"max-width": "65vw"}}>
			{getIcon(mime)}
			<span><b> {name} </b></span>
			<span className="msg-length"/>
			{size && <span><T className="d-inline" i18nKey="VCC_XMSG_ITEM_SIZE">x</T>: {size} </span>}
			<span><T className="d-inline" i18nKey="VCC_XMSG_ITEM_FORMAT">x</T>: {mime}</span>
		</small>,
	]);
}

export type Props = { content: string, entity: Entity };
export type State = { content: any, loading: boolean };

export class AttachmentBody extends Component<Props, State> {
	css: string;
	state: State = {
		content: null,
		loading: true,
	};

	async componentDidMount() {
		const url = Configuration.endpoint + "/attachment/" + this.props.content;
		let content;
		this.css = this.props.entity === Entity.visitor ? "m-1 v-bubble" : "bg-light m-1 a-bubble";
		try {
			// fetch mimetype
			const result = await (await fetch(Configuration.endpoint + "/attachment/" + this.props.content + "/metadata", {credentials: "include"})).json();
			const size = result.size ? formatSize(result.size) : undefined;
			content = (
				<div className={(this.props.entity === Entity.visitor ? "align-items-end" : "align-items-start") + " d-flex flex-column"}>
					{renderAttachment(result.format, result.name, url, size, this.css)}
				</div>
			);
		} catch (e) {
			content = (
				<Card className={this.css}>
					<CardBody>
						<Error className="text-danger mr-2 d-inline"/>
						<CardText className="d-inline"><T className="d-inline" i18nKey="VCC_XMSG_ATTACH_FAIL">x</T></CardText>
					</CardBody>
				</Card>
			);
		}
		this.setState({content});
	}

	render() {
		if (!this.state.content) {
			return (
				<Card className={this.css} style={{width: "65vw"}}>
					<CardBody className="d-flex justify-content-center">
						<div className="spinner-animation border-info border-top border-left rounded-circle m-4" style={{width: "50px", height: "50px"}}/>
					</CardBody>
				</Card>
			);
		} else {
			return this.state.content;
		}
	}
}
